import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './back-to-top-control.scss';

applyTranslations(require('./back-to-top-control.i18n.json'));

type Props = {
  isLoading: boolean,
  show: boolean
};

const msgKey = 'back_to_top_control';

class BackToTopControl extends React.PureComponent<Props> {
  handleBackToTop() {
    window.scrollTo(0, 0);
  }

  render(): React.ReactNode {
    const { isLoading, show } = this.props;

    return (
      !isLoading && show && (
        <div className="back-to-top-control">
          <div
            className="back-to-top-control__element"
            title={__t(`${msgKey}.labels.back_to_top`)}
            onClick={this.handleBackToTop}
          >
            <SVGDynamicIcon
              name="arrow-up-custom-bg"
              width={15}
              height={17}
              customColor="white"
            />
          </div>
        </div>
      )
    );
  }
}

export default BackToTopControl;
